module.exports = __webpack_public_path__ + "20241203142717/img/wx_sh.4e175bb4.png";